export default __webpack_public_path__ + "97c7a36.png";